<span
  *ngIf="shouldRender"
  #wrap
  class="price-wrap"
  [class.is-inline]="effectiveLayout === 'inline'"
  [class.is-stack]="effectiveLayout === 'stack'"
  [class.is-auto]="layout === 'auto'"
>
  <!-- PRIMARY -->
  <span class="price-line primary">
    <span class="integer">{{ primaryParts.integer }}</span>
    <span class="fraction">{{ primaryParts.fraction }}</span>
    <span class="space">&nbsp;</span>
    <span class="symbol">{{ primaryParts.symbol }}</span>
  </span>

  <!-- SECONDARY -->
  <span *ngIf="secondaryParts as s" class="price-line secondary">
    <span class="paren">(</span>
    <span class="integer">{{ s.integer }}</span>
    <span class="fraction">{{ s.fraction }}</span>
    <span class="space">&nbsp;</span>
    <span class="symbol">{{ s.symbol }}</span>
    <span class="paren">)</span>
  </span>
</span>
